import React from 'react';
import PropTypes from 'prop-types';

import Block from './Block';

const propTypes = {
    blocks: PropTypes.array,
};

const defaultProps = {
    blocks: [
        {
            type: 'link',
            url: '/docs/IASYC-poster_8-5x11_DIY.pdf',
            link: 'Download the poster',
            description: 'The official **I Am Still Your Child** film poster with room for you to add the date, time, and place of your screening.',
        },
        {
            type: 'link',
            url: '/docs/IASYC_discussion_guide_23feb2018.pdf',
            link: 'Download the discussion starter guide',
            description: 'For leading a conversation after the screening',
        },
        {
            type: 'link',
            url: '/docs/IASYC_Social_Media_Tips_27sept2017.pdf',
            link: 'Download the social media tips',
            description: 'To promote your screening and connect with our larger impact campaign',
        },
        {
            type: 'link',
            url: 'mailto:iamstillyourchild@catbirdproductions.ca',
            target: 'self',
            title: 'Let us know about your screening',
            link: 'Send information',
            description: 'about your time, date, venue. **So we can promote it, too!**',
        },
    ],
};

const FilmMaterials = ({ blocks }) => (
    <div className="materials">
        <Block blocks={blocks} />
    </div>
);

FilmMaterials.propTypes = propTypes;
FilmMaterials.defaultProps = defaultProps;

export default FilmMaterials;



// WEBPACK FOOTER //
// ./components/partials/FilmMaterials.jsx